#import "../../../../../core-entity/graphql/fragments/widget-fragment-full.graphql"

fragment StagesetWidgetsFragment on Stageset {
    id
    name
    workspaceWidgets {
        ...WidgetFragmentFull
    }
    sidebarWidgets {
        ...WidgetFragmentFull
    }
}
